import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatGoalStateModel } from 'src/app/model/cat-goal-state.model';

@Injectable({
  providedIn: 'root'
})
export class CatGoalStateService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  catalog=()=> {
    return this.http.get(`${this.url}/CatGoalState/Catalog`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAll=()=> {
    return this.http.get(`${this.url}/CatGoalState/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAllActive=()=> {
    return this.http.get(`${this.url}/CatGoalState/List`)
      .pipe(
        map((resp:any)=> resp.filter(goal=> goal.activeId))
      );
  }

  
  save=(state:CatGoalStateModel)=> {
    return this.http.post(`${this.url}/CatGoalState/SaveUpdate`, state)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(state:CatGoalStateModel)=> {
    return this.http.post(`${this.url}/CatGoalState/SaveUpdate/${state.stateGoalId}`, state)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
